const MODULE_URL = 'menus';
export default {
  MODULE_URL: MODULE_URL,

  ICON_TYPE_ID: 'semantic',

  QUEUE_BUNDLE: 'queue_bundle',
  QUEUE_FILE: 'queue_file',
  TRANSFER: 'transfer',
  SHARE_ROOT: 'share_root',
  FAVORITE_HUB: 'favorite_hub',
  USER: 'user',
  HINTED_USER: 'hinted_user',
  EXTENSION: 'extension',

  HUB_USER: 'hub_user',
  GROUPED_SEARCH_RESULT: 'grouped_search_result',
  FILELIST_ITEM: 'filelist_item',

  HUB_MESSAGE_HIGHLIGHT: 'hub_message_highlight',
  PRIVATE_CHAT_MESSAGE_HIGHLIGHT: 'private_chat_message_highlight',

  QUEUE: 'queue',
  SEARCH_INSTANCE: 'search_instance',
  TRANSFERS: 'transfers',
  SHARE_ROOTS: 'share_roots',
  FAVORITE_HUBS: 'favorite_hubs',
  EVENTS: 'events',

  HUB: 'hub',
  PRIVATE_CHAT: 'private_chat',
  FILELIST: 'filelist',
  VIEW_FILE: 'view_file',
};

export const MENU_SUPPORTS = ['urls', 'form'];
export const MENU_NESTING_THRESHOLD = 1;
